/* ============================================================
   Preferiti Multibrand.

   La lista vive nel browser di chi guarda (localStorage), quindi
   non serve nessuna app e non costa niente. Si salva solo l'handle
   del prodotto: titolo, foto, prezzo e disponibilita si rileggono
   da Shopify quando si apre il pop-up, cosi non invecchiano mai.
   ============================================================ */

(function () {
  'use strict';

  var CHIAVE = 'mb_preferiti';
  var dialogo = null;

  /* ---------- deposito ---------- */

  function leggi() {
    try {
      var grezzo = window.localStorage.getItem(CHIAVE);
      var lista = grezzo ? JSON.parse(grezzo) : [];
      return Array.isArray(lista) ? lista.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function scrivi(lista) {
    try {
      window.localStorage.setItem(CHIAVE, JSON.stringify(lista));
    } catch (e) {
      /* finestra privata o spazio pieno: la pagina continua a funzionare */
    }
  }

  function ha(handle) {
    return leggi().indexOf(handle) !== -1;
  }

  function inverti(handle) {
    var lista = leggi();
    var i = lista.indexOf(handle);
    if (i === -1) { lista.unshift(handle); } else { lista.splice(i, 1); }
    scrivi(lista);
    dipingi();
    return i === -1;
  }

  function togli(handle) {
    var lista = leggi().filter(function (h) { return h !== handle; });
    scrivi(lista);
    dipingi();
  }

  function svuota() {
    scrivi([]);
    dipingi();
  }

  /* ---------- stato visibile ---------- */

  function dipingi() {
    var lista = leggi();

    document.querySelectorAll('[data-pref-cuore]').forEach(function (b) {
      var dentro = lista.indexOf(b.getAttribute('data-pref-cuore')) !== -1;
      b.setAttribute('aria-pressed', dentro ? 'true' : 'false');
      b.setAttribute('aria-label', dentro ? 'Togli dai preferiti' : 'Metti nei preferiti');
    });

    document.querySelectorAll('[data-pref-conta]').forEach(function (e) {
      e.textContent = lista.length;
      e.hidden = lista.length === 0;
    });

    document.querySelectorAll('[data-pref-apri]').forEach(function (b) {
      b.setAttribute('data-pieno', lista.length ? '1' : '0');
    });
  }

  /* ---------- prezzi ---------- */

  function euro(centesimi) {
    try {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(centesimi / 100);
    } catch (e) {
      return (centesimi / 100).toFixed(2) + ' €';
    }
  }

  /* ---------- icone ---------- */

  function svgCuore() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7-4.6-7-9.4A4.1 4.1 0 0 1 12 7.8a4.1 4.1 0 0 1 7 2.8c0 4.8-7 9.4-7 9.4z"/></svg>';
  }

  function svgX() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  }

  /* ---------- pop-up ---------- */

  function guscio() {
    var d = document.createElement('dialog');
    d.className = 'mbpf-dialogo';
    d.setAttribute('aria-label', 'I tuoi preferiti');

    var dentro = document.createElement('div');
    dentro.className = 'mbpf-dialogo__in';

    var capo = document.createElement('div');
    capo.className = 'mbpf-dialogo__capo';
    var tit = document.createElement('h2');
    tit.className = 'mbpf-dialogo__t';
    tit.textContent = 'I tuoi preferiti';
    var n = document.createElement('span');
    n.className = 'mbpf-dialogo__n';
    n.setAttribute('data-pref-intestazione', '');
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'mbpf-dialogo__x';
    x.setAttribute('aria-label', 'Chiudi');
    x.innerHTML = svgX();
    x.addEventListener('click', function () { d.close(); });
    var sx = document.createElement('div');
    sx.style.display = 'flex';
    sx.style.alignItems = 'baseline';
    sx.style.gap = '10px';
    sx.appendChild(tit);
    sx.appendChild(n);
    capo.appendChild(sx);
    capo.appendChild(x);

    var ul = document.createElement('ul');
    ul.className = 'mbpf-lista';
    ul.setAttribute('data-pref-lista', '');

    var piede = document.createElement('div');
    piede.className = 'mbpf-dialogo__piede';
    var sv = document.createElement('button');
    sv.type = 'button';
    sv.className = 'mbpf-dialogo__svuota';
    sv.textContent = 'Svuota la lista';
    sv.addEventListener('click', function () { svuota(); riempi(); });
    var vai = document.createElement('a');
    vai.className = 'mbpf-dialogo__vai';
    vai.href = '/collections/all';
    vai.textContent = 'Continua a guardare';
    piede.appendChild(sv);
    piede.appendChild(vai);

    dentro.appendChild(capo);
    dentro.appendChild(ul);
    dentro.appendChild(piede);
    d.appendChild(dentro);

    d.addEventListener('click', function (ev) {
      if (ev.target === d) d.close();
    });

    document.body.appendChild(d);
    return d;
  }

  function vuoto(ul) {
    var li = document.createElement('li');
    li.className = 'mbpf-vuoto';
    li.innerHTML = svgCuore();
    var b = document.createElement('b');
    b.textContent = 'Non hai ancora preferiti';
    var s = document.createElement('span');
    s.textContent = 'Tocca il cuore su un prodotto e lo ritrovi qui, anche quando torni.';
    li.appendChild(b);
    li.appendChild(s);
    ul.appendChild(li);
  }

  function riga(p) {
    var variante = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) { variante = p.variants[i]; break; }
    }
    var disponibile = !!variante;
    if (!variante) variante = p.variants[0];

    var li = document.createElement('li');
    li.className = 'mbpf-riga';

    var foto = document.createElement('span');
    foto.className = 'mbpf-riga__foto';
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
      img.alt = '';
      img.loading = 'lazy';
      foto.appendChild(img);
    }

    var corpo = document.createElement('div');
    corpo.className = 'mbpf-riga__corpo';
    var a = document.createElement('a');
    a.className = 'mbpf-riga__nome';
    a.href = '/products/' + p.handle;
    a.textContent = p.title;
    var pr = document.createElement('span');
    pr.className = 'mbpf-riga__prezzo';
    pr.textContent = euro(variante.price);
    var st = document.createElement('span');
    st.className = 'mbpf-riga__stato';
    st.textContent = disponibile ? 'Disponibile' : 'Non disponibile';
    corpo.appendChild(a);
    corpo.appendChild(pr);
    corpo.appendChild(st);

    var az = document.createElement('div');
    az.className = 'mbpf-riga__az';
    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'mbpf-riga__add';
    add.textContent = disponibile ? 'Aggiungi' : 'Esaurito';
    add.disabled = !disponibile;
    add.addEventListener('click', function () {
      add.disabled = true;
      add.textContent = 'Attendi';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variante.id, quantity: 1 }] })
      }).then(function (r) {
        add.textContent = r.ok ? 'Aggiunto' : 'Riprova';
        if (r.ok) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (!r.ok) add.disabled = false;
      }).catch(function () {
        add.textContent = 'Riprova';
        add.disabled = false;
      });
    });
    var via = document.createElement('button');
    via.type = 'button';
    via.className = 'mbpf-riga__via';
    via.textContent = 'Togli';
    via.addEventListener('click', function () { togli(p.handle); riempi(); });
    az.appendChild(add);
    az.appendChild(via);

    li.appendChild(foto);
    li.appendChild(corpo);
    li.appendChild(az);
    return li;
  }

  function riempi() {
    if (!dialogo) return;
    var ul = dialogo.querySelector('[data-pref-lista]');
    var cap = dialogo.querySelector('[data-pref-intestazione]');
    var lista = leggi();

    ul.textContent = '';
    if (cap) cap.textContent = lista.length ? lista.length + (lista.length === 1 ? ' prodotto' : ' prodotti') : '';

    if (!lista.length) { vuoto(ul); return; }

    var attesa = document.createElement('li');
    attesa.className = 'mbpf-vuoto';
    attesa.innerHTML = '<span>Carico i prodotti</span>';
    ul.appendChild(attesa);

    Promise.all(lista.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (prodotti) {
      ul.textContent = '';
      var vivi = prodotti.filter(Boolean);

      /* un prodotto tolto dal catalogo esce anche dalla lista */
      if (vivi.length !== lista.length) {
        scrivi(vivi.map(function (p) { return p.handle; }));
        dipingi();
      }
      if (!vivi.length) { vuoto(ul); return; }
      vivi.forEach(function (p) { ul.appendChild(riga(p)); });
      if (cap) cap.textContent = vivi.length + (vivi.length === 1 ? ' prodotto' : ' prodotti');
    });
  }

  function apri() {
    if (!dialogo) dialogo = guscio();
    riempi();
    if (typeof dialogo.showModal === 'function') { dialogo.showModal(); } else { dialogo.setAttribute('open', ''); }
  }

  /* ---------- ascolti ---------- */

  document.addEventListener('click', function (ev) {
    var cuore = ev.target.closest ? ev.target.closest('[data-pref-cuore]') : null;
    if (cuore) {
      ev.preventDefault();
      ev.stopPropagation();
      inverti(cuore.getAttribute('data-pref-cuore'));
      return;
    }
    var apriBtn = ev.target.closest ? ev.target.closest('[data-pref-apri]') : null;
    if (apriBtn) {
      ev.preventDefault();
      apri();
    }
  });

  /* le sezioni ricaricate dall'editor o dai filtri tornano dipinte */
  document.addEventListener('shopify:section:load', dipingi);
  document.addEventListener('DOMContentLoaded', dipingi);
  if (document.readyState !== 'loading') dipingi();

  window.MBPreferiti = { lista: leggi, ha: ha, inverti: inverti, togli: togli, svuota: svuota, apri: apri };
})();
